













































import { Vue, Component, Prop } from 'vue-property-decorator'
import { EntryAllCfg, EntryHomeCardListMap } from '@/types/newPersion'
import { StoryLineType } from '@/types/tenant/calcGroup'

import { newPersionList, pensionInsuranceSummaryList } from '@/api/newPersion' // 退休规划相关接口
import { fetchInvestProList } from '@/api/card/investCard' // 保险相关接口
import { CommonMudule } from '@/store/modules/common'
import AnuityProductCfg from '@/views/newPension/pensionCard/annuityProduct/config' // 年金保险配置文件
import lifeProductCfg from '@/views/newPension/pensionCard/lifeProduct/config' // 终生寿险配置文件
import investProductCfg from '@/views/newPension/pensionCard/investCard/config' // 投资产品配置文件

import StoryLayout from '@/common/cardMap/storyLayout/index.vue'
import cardContainer from '@/common/cardMap/cardLayout/cardContainer.vue'
import cardWraper from '@/common/cardMap/cardLayout/cardWraper.vue'
import cardTable from '@/common/cardMap/cardLayout/cardTable.vue'
import cardTableInfo from '@/common/cardMap/cardLayout/cardTableInfo.vue'
import IoCard from '@/common/cardMap/cardLayout/ioCard.vue'
import OutCard from '@/common/cardMap/cardLayout/out-card.vue'

import BaseInfo from '@/views/newPension/components/baseInfo/index.vue'

import TopChartAndTable from './topChartAndTable.vue'
import BottomCard from './bottomCard.vue'
@Component({
  components: {
    cardContainer,
    cardWraper,
    cardTable,
    cardTableInfo,
    IoCard,
    OutCard,
    StoryLayout,

    BaseInfo,

    TopChartAndTable,
    BottomCard,
  },
})
export default class HomeCard extends Vue {
  @Prop() entryAllCfg!: EntryAllCfg;

  created () {
    this.getStepStatus()
  }

  private async getStepStatus () {
    const customerIdObj = { customerId: CommonMudule.customerId }
    const _persionForm = await newPersionList(customerIdObj)
    if (_persionForm?.data?.retireAge && _persionForm?.data?.deathAge) {
      const _proList = await Promise.all([
        pensionInsuranceSummaryList({
          ...customerIdObj,
          insuranceType: AnuityProductCfg.insuranceType,
          storyLineType: AnuityProductCfg.planType,
        }),
        pensionInsuranceSummaryList({
          ...customerIdObj,
          insuranceType: lifeProductCfg.insuranceType,
          storyLineType: lifeProductCfg.planType,
        }),
        fetchInvestProList({
          customerId: CommonMudule.customerId,
          storyLineType: investProductCfg.planType as StoryLineType,
        }),
      ])
      if (
      _proList[0]?.data &&
      _proList[1]?.data &&
      _proList[2]?.data
      ) {
        const _persionFormD = _persionForm.data
        const _list: boolean[] = [
          this.handlePersionForm(_persionFormD, [
            'retireAge',
            'deathAge',
            'currentMonthAmount',
            'assumeInflationRate',
          ]),
          this.handlePersionFormSingle(_persionFormD, [
            'currentInsuranceAmount',
            'currentRentAmount',
            'currentAnnuityAmount',
            'currentOtherAmount',
          ]),
          this.handleProRes(_proList),
        ]
        for (let i = 0; i < _list.length; i++) {
          if (_list[i]) {
            this.getTopChartAndTableRef()
            break
          }
        }
        this.$emit('on-change-step-status', _list)
      }
    }
  }

  private handleProRes (_proList: { data: [] }[]): boolean {
    let flag = false
    for (let i = 0; i < _proList.length; i++) {
      const _proListItem = _proList[i]
      if (_proListItem.data?.length) {
        flag = true
        break
      }
    }
    return flag
  }

  private handlePersionForm (_persionFormD: {}, _ruleList: string[]): boolean {
    let flag = true
    for (let i = 0; i < _ruleList.length; i++) {
      if (!_persionFormD[_ruleList[i]]) {
        flag = false
        break
      }
    }
    return flag
  }

  private handlePersionFormSingle (
    _persionFormD: {},
    _ruleList: string[]
  ): boolean {
    let flag = false
    for (let i = 0; i < _ruleList.length; i++) {
      if (_persionFormD[_ruleList[i]]) {
        flag = true
        break
      }
    }
    return flag
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handleEditBtn (status: string, idx: number) {
    if (status === 'ok') {
      this.getTopChartAndTableRef()
      this.getStepStatus()
    }
    this.$emit('on-edit-btn')
  }

  private handleToPage (item: EntryHomeCardListMap, idx: number) {
    this.$emit('on-to-page', item, idx)
  }

  private getTopChartAndTableRef () {
    ((this.$refs.topChartAndTableRef as unknown) as {
      getData: () => void
    }).getData()
  }
}
